import SearchService, {
    ContentItem,
    Product,
} from "../services/search.service";

export function notifyClick(e: Event, item: Product | ContentItem) {
    SearchService.notifyClick(item.ticket);
}
